module.exports = __webpack_public_path__ + "static/media/AI_20.245ecc4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_20.png
// module id = 135
// module chunks = 0